module.exports = __webpack_public_path__ + "img/1516665400.99e27691.jpg";